/**
 * @function makeWholeSlideOverlay
 * @desc Creates the overlay seen on whole slide when:
 * 1) Premeris tile is clicked on Premeris View and whole slide navigates to the right region
 * 2) Custom selection is made with the selection plugin
 * @param {number} id the id of the element, and the id shown in the corner of the overlay
 * @returns {overlay element}
 */
export const makeWholeSlideOverlay = (id, regOrBlue, stain) => {
  const overlay = document.createElement('div')
  let color = regOrBlue === 'reg' ? 'red' : 'blue'
  let textColor = 'black'

  // account for modified pap - change color
  if (stain === 'modified pap') {
    color = 'black'
    textColor = 'black'
  }
  overlay.style.outline = `18px auto ${color}`
  overlay.style.color = textColor
  overlay.style.minWidth = '36px'
  overlay.style.minHeight = '28px'

  const overlayChild = document.createElement('div')
  overlayChild.style.fontWeight = 700
  overlayChild.style.paddingLeft = '5px'
  overlay.append(overlayChild)

  if (id) {
    overlay.id = regOrBlue === 'reg' ? `${id}` : `blue_${id}`
    overlayChild.innerHTML = id
  }

  return overlay
}

/**
 * @function makePremerisMovieOverlay
 * @desc Make green Premeris overlay for Premeris Movie
 * @returns {overlay element}
 */
export const makePremerisMovieOverlay = () => {
  const premerisOverlay = document.createElement('div')
  premerisOverlay.id = `premeris-movie-overlay`
  premerisOverlay.classList.add(`premeris-movie-overlay`)
  return premerisOverlay
}

export const makeImageSelectionElement = (confirmClickHandler, cancelClickHandler) => {
  const element = document.createElement('div')
  element.style.width = '300px'
  element.style.height = '200px'
  element.style.maxWidth = '300px'
  element.style.maxHeight = '200px'
  element.style.minWidth = '300px'
  element.style.minHeight = '200px'
  element.className = 'selectionBox'
  element.id = 'selectionBox'

  const confirm = document.createElement('img')
  confirm.style.position = 'absolute'
  confirm.style.top = '75%'
  confirm.style.left = '50%'
  confirm.style.transform = 'translate(-100%, -50%)'
  confirm.addEventListener('click', confirmClickHandler)
  element.appendChild(confirm)

  const cancel = document.createElement('img')
  cancel.style.position = 'absolute'
  cancel.style.top = '75%'
  cancel.style.left = '50%'
  cancel.style.transform = 'translate(0, -50%)'
  cancel.addEventListener('click', cancelClickHandler)
  element.appendChild(cancel)

  return element
}

/**
 * @function makeClassifierAddToSummaryOverlay
 * @desc Creates the add icon that is placed on each Premeris tile on Classifier viewer.
 * @param {number} clid The id of each Premeris tile
 * @returns overlay element
 */
export const makeClassifierAddToSummaryOverlay = (clid) => {
  const overlay = document.createElement('div')
  overlay.classList.add('popover__wrapper')
  overlay.id = `summaryOverlay_${clid}`
  overlay.setAttribute('clid', clid)

  const summaryImg = document.createElement('img')
  // summaryImg.src = addIcon
  summaryImg.classList.add('popover__content')
  summaryImg.id = `summaryImg_${clid}`

  overlay.append(summaryImg)

  return overlay
}
